/* Guide des tailles HTML : affordance de défilement horizontal du tableau.
   Le panneau est déplacé sur <body> par size-guide.js puis affiché par
   <modal-dialog> : on (re)mesure à l'ouverture, sinon les largeurs sont
   celles d'un élément encore invisible. */
(function () {
  'use strict';

  function sync(scroller) {
    var wrap = scroller.querySelector('[data-sgh-scroll]');
    if (!wrap) return;
    var slack = wrap.scrollWidth - wrap.clientWidth;
    scroller.classList.toggle('is-scrollable', slack > 4);
    scroller.classList.toggle('is-end', wrap.scrollLeft >= slack - 4);
  }

  function init(scroller) {
    if (scroller.dataset.sghInit) return;
    scroller.dataset.sghInit = '1';
    var wrap = scroller.querySelector('[data-sgh-scroll]');
    if (!wrap) return;
    wrap.addEventListener('scroll', function () { sync(scroller); }, { passive: true });
    sync(scroller);
  }

  function initAll(root) {
    (root || document).querySelectorAll('.sgh-scroller').forEach(init);
  }

  /* Intro repliée sur mobile : on ne la replie que si elle dépasse vraiment,
     sinon le « Voir plus » n'ouvrirait rien. */
  var MOBILE = '(max-width: 749px)';

  function initIntro(intro) {
    var btn = intro.parentElement.querySelector('[data-sgh-more]');
    if (!btn) return;

    if (!btn.dataset.sghInit) {
      btn.dataset.sghInit = '1';
      btn.addEventListener('click', function () {
        var clamped = intro.classList.toggle('is-clamped');
        btn.querySelector('[data-sgh-more-open]').hidden = !clamped;
        btn.querySelector('[data-sgh-more-close]').hidden = clamped;
        btn.setAttribute('aria-expanded', clamped ? 'false' : 'true');
      });
    }

    if (!window.matchMedia(MOBILE).matches) {
      intro.classList.remove('is-clamped');
      btn.hidden = true;
      return;
    }

    intro.classList.add('is-clamped');
    var overflows = intro.scrollHeight - intro.clientHeight > 8;
    btn.hidden = !overflows;
    btn.setAttribute('aria-expanded', 'false');
    btn.querySelector('[data-sgh-more-open]').hidden = false;
    btn.querySelector('[data-sgh-more-close]').hidden = true;
    if (!overflows) intro.classList.remove('is-clamped');
  }

  function introAll(root) {
    (root || document).querySelectorAll('[data-sgh-intro]').forEach(initIntro);
  }

  function syncAll(root) {
    (root || document).querySelectorAll('.sgh-scroller').forEach(sync);
  }

  function boot() {
    initAll();
    introAll();

    /* l'attribut open est posé par ModalDialog.show() : c'est le seul moment
       où le tableau a des dimensions réelles */
    document.querySelectorAll('.sgh-modal').forEach(function (modal) {
      new MutationObserver(function () {
        if (modal.hasAttribute('open')) {
          initAll(modal);
          syncAll(modal);
          introAll(modal);
        }
      }).observe(modal, { attributes: true, attributeFilter: ['open'] });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('resize', function () {
    syncAll();
    introAll();
  });

  /* ------------------------------------------------------------------
     Brassière : calcul de la taille à partir des deux mesures. Les chiffres
     sont lus dans le tableau rendu par le snippet (une seule source) :
     ligne = tour de dos (data-under « 68-72 »), case = bonnet (data-bust).
     « Choisir 90C » coche la taille sur la fiche (pdp-v2.js, pdp:bra-pick)
     puis ferme le guide. Délégation sur document : la modale est déplacée
     sur <body> après le chargement.
     ------------------------------------------------------------------ */
  function range(text) {
    var p = String(text || '').split('-');
    return [parseInt(p[0], 10), parseInt(p[1], 10)];
  }

  function fill(tpl, vars) {
    return String(tpl || '').replace(/\[(\w+)\]/g, function (m, k) {
      return vars && vars[k] != null ? vars[k] : m;
    });
  }

  function strings(box) {
    if (box.sgbStrings) return box.sgbStrings;
    var el = box.querySelector('[data-sgb-strings]');
    var raw = {};
    try { raw = JSON.parse(el ? el.textContent : '{}'); } catch (e) { raw = {}; }
    /* le filtre t échappe l'apostrophe (l&#39;unité) : on décode */
    var t = document.createElement('textarea');
    Object.keys(raw).forEach(function (k) { t.innerHTML = raw[k]; raw[k] = t.value; });
    box.sgbStrings = raw;
    return raw;
  }

  function measure(input) {
    var v = parseFloat(String(input ? input.value : '').replace(',', '.'));
    return v > 0 ? Math.round(v) : null;
  }

  function compute(box) {
    var under = measure(box.querySelector('[data-sgb-in="under"]'));
    var bust = measure(box.querySelector('[data-sgb-in="bust"]'));
    var s = strings(box);
    if (under === null || bust === null) return { msg: s.empty };
    var rows = Array.prototype.slice.call(box.querySelectorAll('tr[data-tour]'));
    if (!rows.length) return { msg: s.empty };
    var row = rows.filter(function (r) {
      var u = range(r.getAttribute('data-under'));
      return under >= u[0] && under <= u[1];
    })[0];
    if (!row) {
      var first = range(rows[0].getAttribute('data-under'));
      var last = range(rows[rows.length - 1].getAttribute('data-under'));
      return under < first[0]
        ? { msg: fill(s.bandSmall, { min: first[0] }), warn: true }
        : { msg: fill(s.bandBig, { max: last[1] }), warn: true };
    }
    var tour = row.getAttribute('data-tour');
    var cells = Array.prototype.slice.call(row.querySelectorAll('td[data-bust]'));
    var hit = cells.filter(function (c) {
      var b = range(c.getAttribute('data-bust'));
      return bust >= b[0] && bust <= b[1];
    })[0];
    if (!hit) {
      if (!cells.length) return { msg: s.empty };
      var lo = range(cells[0].getAttribute('data-bust'));
      var edge = bust < lo[0] ? cells[0] : cells[cells.length - 1];
      return {
        row: row,
        msg: fill(bust < lo[0] ? s.cupSmall : s.cupBig, { tour: tour, cup: edge.getAttribute('data-cup') }),
        warn: true,
      };
    }
    return { row: row, cell: hit, tour: tour, cup: hit.getAttribute('data-cup') };
  }

  function paintBra(box) {
    var res = compute(box);
    var s = strings(box);
    box.querySelectorAll('tr.is-row').forEach(function (r) { r.classList.remove('is-row'); });
    box.querySelectorAll('td.is-hit').forEach(function (c) { c.classList.remove('is-hit'); });
    if (res.row) res.row.classList.add('is-row');
    if (res.cell) res.cell.classList.add('is-hit');
    var scroller = box.querySelector('.sgh-scroller');
    if (scroller) sync(scroller);
    var out = box.querySelector('[data-sgb-res]');
    if (!out) return;
    out.textContent = '';
    if (!res.cup) {
      var p = document.createElement('p');
      p.className = 'sgb__msg' + (res.warn ? ' is-warn' : '');
      p.textContent = res.msg || '';
      out.appendChild(p);
      return;
    }
    var size = res.tour + res.cup;
    var line = document.createElement('p');
    line.className = 'sgb__size';
    line.appendChild(document.createTextNode(s.result + ' '));
    var strong = document.createElement('strong');
    strong.textContent = size;
    line.appendChild(strong);
    out.appendChild(line);
    /* le bouton n'a de sens que si la fiche a le sélecteur tour de dos / bonnet */
    if (document.querySelector('fieldset[data-pdp-bonnet]')) {
      var go = document.createElement('button');
      go.type = 'button';
      go.className = 'sgb__go';
      go.setAttribute('data-sgb-go', '');
      go.setAttribute('data-tour', res.tour);
      go.setAttribute('data-cup', res.cup);
      go.textContent = fill(s.choose, { size: size });
      out.appendChild(go);
    }
    /* la case trouvée reste visible dans le tableau qui défile sur mobile */
    var wrap = res.cell.closest('[data-sgh-scroll]');
    if (wrap) {
      var c = res.cell.getBoundingClientRect();
      var w = wrap.getBoundingClientRect();
      var sticky = res.row.querySelector('th');
      var left = w.left + (sticky ? sticky.offsetWidth : 0);
      if (c.left < left) wrap.scrollLeft -= left - c.left + 8;
      else if (c.right > w.right) wrap.scrollLeft += c.right - w.right + 8;
    }
  }

  document.addEventListener('input', function (event) {
    var input = event.target.closest && event.target.closest('[data-sgb-in]');
    if (!input) return;
    var box = input.closest('[data-sgb]');
    if (box) paintBra(box);
  });

  document.addEventListener('click', function (event) {
    var go = event.target.closest && event.target.closest('[data-sgb-go]');
    if (!go) return;
    document.dispatchEvent(
      new CustomEvent('pdp:bra-pick', {
        detail: { tour: go.getAttribute('data-tour'), cup: go.getAttribute('data-cup') },
      })
    );
    var modal = go.closest('modal-dialog');
    if (modal && typeof modal.hide === 'function') modal.hide();
  });
})();
